if (!Array.prototype.first) {
    Array.prototype.first = function (condition) {
        return condition ? this.find(condition) : this[0]
    }
}

if (!Array.prototype.last) {
    Array.prototype.last = function () {
        return this[this.length - 1]
    }
}

if (!Array.prototype.any) {
    Array.prototype.any = function (condition) {
        if (condition) {
            return this.find(condition) != null
        }
        return this.length > 0
    }
}

if (!Array.prototype.all) {
    Array.prototype.all = function (condition) {
        if (condition) {
            for (var i = 0; i < this.length; i++) {
                if (!condition(this[i])) {
                    return false
                }
            }
        }
        return true
    }
}

if (!Array.prototype.where) {
    Array.prototype.where = function (condition) {
        var ret = []
        for (var i = 0; i < this.length; i++) {
            if (condition(this[i], i)) {
                ret.push(this[i])
            }
        }
        return ret
    }
}

if (!Array.prototype.textualize) {
    Array.prototype.textualize = function (finalJoinWord) {
        if (this.length == 1) {
            return this[0]
        }

        var firstSection = this.filter((t, i) => i != this.length - 1).join(', ')
        return `${firstSection} ${finalJoinWord} ${this[this.length - 1]}`
    }
}

if (!Array.prototype.remove) {
    Array.prototype.remove = function (value) {
        var index = this.indexOf(value)
        this.removeAt(index)
    }
}

if (!Array.prototype.removeAt) {
    Array.prototype.removeAt = function (index) {
        if (index > -1) {
            this.splice(index, 1)
        }
    }
}

if (!Array.prototype.removeWhere) {
    Array.prototype.removeWhere = function (callback) {
        var i = this.length
        while (i--) {
            if (callback(this[i], i)) {
                this.splice(i, 1)
            }
        }
    }
}

if (!Array.prototype.findIndex) {
    Array.prototype.findIndex = function (selector) {
        var i = 0
        while (i < this.length) {
            if (selector(this[i], i)) {
                return true
            }
            i++
        }
        return false
    }
}

if (!Array.prototype.clear) {
    Array.prototype.clear = function () {
        while (this.pop()) {}
        return
    }
}

if (!Array.prototype.toObject) {
    Array.prototype.toObject = function (get_key, get_value) {
        if (get_value) {
            if (typeof get_value !== 'function') {
                throw 'get_value callback must be a function'
            }
        } else {
            get_value = (v) => v
        }

        if (get_key) {
            if (typeof get_key !== 'function') {
                throw 'get_key callback must be a function'
            }

            return this.reduce((obj, item, index) => {
                var key = get_key(item, index, this)
                var value = get_value(item, index, this)
                return (obj[key] = value), obj
            }, {})
        }

        return this.reduce((obj, item) => {
            return (obj[item] = null), obj
        }, {})
    }
}

if (!Array.prototype.groupBy) {
    Array.prototype.groupBy = function (get_key, get_value) {
        if (get_value) {
            if (typeof get_value !== 'function') {
                throw 'get_value callback must be a function'
            }
        } else {
            get_value = (v) => v
        }

        if (get_key) {
            if (typeof get_key !== 'function') {
                var origKey = get_key
                get_key = (v) => v[origKey]
            }

            return this.reduce((obj, item, index) => {
                var key = get_key(item, index, this)
                var value = get_value(item, index, this)
                if (!obj.hasOwnProperty(key)) {
                    return (obj[key] = [value]), obj
                } else {
                    return obj[key].push(value), obj
                }
            }, {})
        } else {
            throw 'must provide a function returning a value to group on'
        }
    }
}

if (!Array.prototype.maxBy) {
    Array.prototype.maxBy = function (get_comparison_value) {
        return this.max(get_comparison_value, (v) => v)
    }
}

if (!Array.prototype.max) {
    Array.prototype.max = function (get_comparison_value, return_val) {
        if (get_comparison_value) {
            if (typeof get_comparison_value !== 'function') {
                throw 'get_comparison_value callback must be a function'
            }
        } else {
            get_comparison_value = (v) => v
        }

        if (return_val) {
            if (typeof return_val !== 'function') {
                throw 'return_val callback must be a function'
            }
        } else {
            return_val = get_comparison_value
        }

        if (this.any()) {
            var max = this[0]

            for (var i = 1; i < this.length; i++) {
                if (get_comparison_value(this[i]) > get_comparison_value(max)) {
                    max = this[i]
                }
            }

            return return_val(max)
        } else {
            return null
        }
    }
}

if (!Array.prototype.minBy) {
    Array.prototype.minBy = function (get_comparison_value) {
        return this.min(get_comparison_value, (v) => v)
    }
}

if (!Array.prototype.min) {
    Array.prototype.min = function (get_comparison_value, return_val) {
        if (get_comparison_value) {
            if (typeof get_comparison_value !== 'function') {
                throw 'get_comparison_value callback must be a function'
            }
        } else {
            get_comparison_value = (v) => v
        }

        if (return_val) {
            if (typeof return_val !== 'function') {
                throw 'return_val callback must be a function'
            }
        } else {
            return_val = get_comparison_value
        }

        if (this.any()) {
            var min = this[0]

            for (var i = 1; i < this.length; i++) {
                if (get_comparison_value(this[i]) < get_comparison_value(min)) {
                    min = this[i]
                }
            }

            return return_val(min)
        } else {
            return null
        }
    }
}

if (!Array.prototype.distinct) {
    Array.prototype.distinct = function (selector) {
        if (selector) {
            if (typeof selector !== 'function') {
                throw 'selector must be an arrow function'
            }
            return [...new Set(this.map(selector))]
        }
        return [...new Set(this)]
    }
}

if (!Array.prototype.distinctBy) {
    Array.prototype.distinctBy = function (selector) {
        if (selector) {
            if (typeof selector !== 'function') {
                throw 'selector must be an arrow function'
            }
            var set = this.groupBy(selector)
            return Object.values(set).map((el) => el.first())
        }
        return [...new Set(this)]
    }
}

if (!Array.prototype.nonEmpty) {
    Array.prototype.nonEmpty = function () {
        return this.where((o) => !!o)
    }
}

if (!Array.prototype.nonNull) {
    Array.prototype.nonNull = function () {
        return this.where((o) => o !== null)
    }
}

if (!Array.prototype.defaultSort) {
    Array.prototype.defaultSort = function (selector) {
        selector = selector || ((item) => item)
        return [...this].sort((a, b) => {
            var aStr = selector(a)
            var bStr = selector(b)

            if (aStr == null) {
                return -1
            }
            if (bStr == null) {
                return 1
            }
            if (typeof aStr !== typeof bStr) {
                throw `inconsistent types, can't perform default sort: a = ${aStr}, b = ${bStr}`
            }
            if (typeof aStr === 'string') {
                return aStr.compareIgnore(bStr)
            }
            if (typeof aStr === 'number') {
                return aStr - bStr
            }
            if (typeof aStr.getMonth === 'function') {
                return aStr - bStr
            }
        })
    }
}

if (!Array.prototype.sum) {
    Array.prototype.sum = function (get_value) {
        if (get_value) {
            if (typeof get_value !== 'function') {
                throw 'get_value callback must be a function'
            }
        } else {
            get_value = (v) => v
        }

        return this.reduce(function (a, b) {
            return a + Number(get_value(b))
        }, 0)
    }
}

if (!Array.prototype.contains) {
    Array.prototype.contains = function (val) {
        return this.indexOf(val) > -1
    }
}

if (!Array.prototype.equivalent) {
    Array.prototype.equivalent = function (val, key) {
        if (!Array.isArray(val) || val.length != this.length) {
            return false
        }
        var selector = key
        if (key) {
            if (typeof selector !== 'function') {
                selector = (v) => v[key]
            }
        } else {
            selector = (v) => v
        }
        return this.all((v) => val.map(selector).contains(selector(v)))
    }
}

if (!Array.prototype.skip) {
    Array.prototype.skip = function (value) {
        if (value >= this.length) {
            return []
        }
        return this.slice(value)
    }
}

if (!Array.prototype.shuffle) {
    Array.prototype.shuffle = function () {
        var maxIndex = this.length - 1
        var currentIndex = this.length
        var randomIndex = 0
        // While there remain elements to shuffle...
        while (--currentIndex >= 0) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * maxIndex)
            if (currentIndex == randomIndex) {
                continue
            }
            var temp = this[currentIndex]
            this[currentIndex] = this[randomIndex]
            this[randomIndex] = temp
        }
        return this
    }
}
